var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 230,
    viewBox: "0 0 219 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 115C0 45.4935 50.8744 0 113.13 0C163.692 0 201.616 29.6927 215.2 70.7729H168.749C157.69 52.1276 139.994 40.1258 113.13 40.1258C72.0485 40.1258 43.2934 70.4516 43.2934 115C43.2934 159.548 69.2032 189.874 111.873 189.874C149.475 189.874 170.649 169.651 174.44 148.17H118.508V108.999H219V125.112C219 187.039 172.861 230 111.873 230C48.3506 230 0 184.507 0 115Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeft);
export default __webpack_public_path__ + "static/media/top_left.b2cce41007b4060b300c7198d8a1f1ae.svg";
export { ForwardRef as ReactComponent };